<template>
  <div class="tooltip-container" @mouseover="showTooltip" @mouseleave="hideTooltip">
    <slot></slot>
    <div v-if="show" :class="['tooltip', `tooltip-${placement}`, { '--active': show }]">
      <div class="tooltip-arrow"></div>
      <slot name="content">Default Tooltip Content</slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placement: {
      type: String,
      default: 'bottom',
      validator: (value) => ['top', 'right', 'bottom', 'left'].includes(value),
    },
    content: String,
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    showTooltip() {
      this.show = true
    },
    hideTooltip() {
      this.show = false
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip {
  position: absolute;
  background-color: var(--white);
  color: var(--dark);
  padding: 16px;
  border-radius: 4px;
  z-index: 9999;
  opacity: 0;
  transition: opacity 0.3s;
  pointer-events: none;
  width: 260px;
  box-shadow: 0 2px 2px 0 rgba(60, 75, 100, .14), 0 3px 1px -2px rgba(60, 75, 100, .12), 0 1px 5px 0 rgba(60, 75, 100, .20);
  &.--active {
    opacity: 1;
    pointer-events: auto;
  }
}

.tooltip-top {
  top: -100%;
  left: 50%;
  transform: translateX(-50%);
}

.tooltip-right {
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
}

.tooltip-bottom {
  bottom: -100%;
  left: 50%;
  transform: translateX(-50%);
}

.tooltip-left {
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
}

.tooltip-arrow {
  position: absolute;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent transparent transparent;
}

.tooltip-top .tooltip-arrow {
  bottom: -10px;
  left: 50%;
  margin-left: -5px;
  border-top-color: var(--white);
}

.tooltip-right .tooltip-arrow {
  top: 50%;
  left: -10px;
  margin-top: -5px;
  border-right-color: var(--white);
}

.tooltip-bottom .tooltip-arrow {
  top: -10px;
  left: 50%;
  margin-left: -5px;
  border-bottom-color: var(--white);
}

.tooltip-left .tooltip-arrow {
  top: 50%;
  right: -10px;
  margin-top: -5px;
  border-left-color: var(--white);
}
</style>
